
import Vue from 'vue'
import { DataSet } from '@/services/DataSet'

export default Vue.extend({
   name: 'FilterToggle',
   props: {
      title: { type: String, default: 'Show Inactive' },
      toggledTitle: { type: String, default: 'Hide Inactive' },
      size: { type: String, default: 'btn-sm' },
      type: { type: String, default: 'btn-default' },
      initial: { type: Boolean, default: false },
   },
   data() {
      return {
         filterValue: false,
      }
   },
   computed: {
      displayTitle(): string {
         return this.filterValue ? this.toggledTitle : this.title
      },
   },
   methods: {
      toggleValue() {
         this.filterValue = !this.filterValue
         this.notifyFilterChanged()
      },
      notifyFilterChanged() {
         this.$emit('change', this.filterValue)
      },
   },
   mounted() {
      this.filterValue = this.initial
   },
})
